// client/plugins/quotePlugin.ts
import { InputRule, inputRules } from "prosemirror-inputrules";
function germanSmartQuotesPlugin() {
  return inputRules({
    rules: [
      // Regel für geschlossene doppelte Anführungszeichen: „...“
      new InputRule(/"([^"]+)"$/, (state, match, start, end) => {
        const [, innerText] = match;
        return state.tr.replaceWith(
          start,
          end,
          state.schema.text(`\u201E${innerText}\u201C`)
          // Öffnendes und schließendes Anführungszeichen
        );
      }),
      // Regel für geschlossene einfache Anführungszeichen: ‚...‘
      new InputRule(/'([^']+)'$/, (state, match, start, end) => {
        const [, innerText] = match;
        return state.tr.replaceWith(
          start,
          end,
          state.schema.text(`\u201A${innerText}\u2018`)
          // Einfache Anführungszeichen
        );
      })
    ]
  });
}
var GermanQuotesConfig = {
  plugins: (schema) => [germanSmartQuotesPlugin()]
};
export {
  GermanQuotesConfig,
  germanSmartQuotesPlugin
};
